import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function format$default(obj, builder, minusNotRequired, $super) {
  minusNotRequired = minusNotRequired === VOID ? false : minusNotRequired;
  var tmp;
  if ($super === VOID) {
    this.format_bqb1zl_k$(obj, builder, minusNotRequired);
    tmp = Unit_instance;
  } else {
    tmp = $super.format_bqb1zl_k$.call(this, obj, builder, minusNotRequired);
  }
  return tmp;
}
var FormatterStructureClass;
function FormatterStructure() {
  if (FormatterStructureClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FormatterStructure');
    FormatterStructureClass = $;
  }
  return FormatterStructureClass;
}
var SpacePaddedFormatterClass;
function SpacePaddedFormatter() {
  if (SpacePaddedFormatterClass === VOID) {
    class $ {
      constructor(formatter, padding) {
        this.formatter_1 = formatter;
        this.padding_1 = padding;
      }
      format_bqb1zl_k$(obj, builder, minusNotRequired) {
        // Inline function 'kotlin.let' call
        var it = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        this.formatter_1.format_bqb1zl_k$(obj, it, minusNotRequired);
        var string = it.toString();
        // Inline function 'kotlin.repeat' call
        var times = this.padding_1 - string.length | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            builder.append_58al37_k$(_Char___init__impl__6a9atx(32));
          }
           while (inductionVariable < times);
        builder.append_jgojdo_k$(string);
      }
    }
    protoOf($).format$default_fwaxfk_k$ = format$default;
    initMetadataForClass($, 'SpacePaddedFormatter', VOID, VOID, [FormatterStructure()]);
    SpacePaddedFormatterClass = $;
  }
  return SpacePaddedFormatterClass;
}
var SignedFormatterClass;
function SignedFormatter() {
  if (SignedFormatterClass === VOID) {
    class $ {
      constructor(formatter, allSubFormatsNegative, alwaysOutputSign) {
        this.formatter_1 = formatter;
        this.allSubFormatsNegative_1 = allSubFormatsNegative;
        this.alwaysOutputSign_1 = alwaysOutputSign;
      }
      format_bqb1zl_k$(obj, builder, minusNotRequired) {
        var tmp;
        if (!minusNotRequired && this.allSubFormatsNegative_1(obj)) {
          tmp = _Char___init__impl__6a9atx(45);
        } else if (this.alwaysOutputSign_1) {
          tmp = _Char___init__impl__6a9atx(43);
        } else {
          tmp = null;
        }
        var sign = tmp;
        var tmp_0 = sign;
        if ((tmp_0 == null ? null : new (Char())(tmp_0)) == null)
          null;
        else {
          var tmp_1 = sign;
          // Inline function 'kotlin.let' call
          var it = (tmp_1 == null ? null : new (Char())(tmp_1)).value_1;
          builder.append_58al37_k$(it);
        }
        var tmp_2;
        if (minusNotRequired) {
          tmp_2 = true;
        } else {
          var tmp_3 = sign;
          tmp_2 = equals(tmp_3 == null ? null : new (Char())(tmp_3), new (Char())(_Char___init__impl__6a9atx(45)));
        }
        this.formatter_1.format_bqb1zl_k$(obj, builder, tmp_2);
      }
    }
    protoOf($).format$default_fwaxfk_k$ = format$default;
    initMetadataForClass($, 'SignedFormatter', VOID, VOID, [FormatterStructure()]);
    SignedFormatterClass = $;
  }
  return SignedFormatterClass;
}
var ConditionalFormatterClass;
function ConditionalFormatter() {
  if (ConditionalFormatterClass === VOID) {
    class $ {
      constructor(formatters) {
        this.formatters_1 = formatters;
      }
      format_bqb1zl_k$(obj, builder, minusNotRequired) {
        var _iterator__ex2g4s = this.formatters_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
          var condition = _destruct__k2r9zo.component1_7eebsc_k$();
          var formatter = _destruct__k2r9zo.component2_7eebsb_k$();
          if (condition(obj)) {
            formatter.format_bqb1zl_k$(obj, builder, minusNotRequired);
            return Unit_instance;
          }
        }
      }
    }
    protoOf($).format$default_fwaxfk_k$ = format$default;
    initMetadataForClass($, 'ConditionalFormatter', VOID, VOID, [FormatterStructure()]);
    ConditionalFormatterClass = $;
  }
  return ConditionalFormatterClass;
}
var ConcatenatedFormatterClass;
function ConcatenatedFormatter() {
  if (ConcatenatedFormatterClass === VOID) {
    class $ {
      constructor(formatters) {
        this.formatters_1 = formatters;
      }
      format_bqb1zl_k$(obj, builder, minusNotRequired) {
        var _iterator__ex2g4s = this.formatters_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var formatter = _iterator__ex2g4s.next_20eer_k$();
          formatter.format_bqb1zl_k$(obj, builder, minusNotRequired);
        }
      }
    }
    protoOf($).format$default_fwaxfk_k$ = format$default;
    initMetadataForClass($, 'ConcatenatedFormatter', VOID, VOID, [FormatterStructure()]);
    ConcatenatedFormatterClass = $;
  }
  return ConcatenatedFormatterClass;
}
//region block: exports
export {
  format$default as format$default1689bsnf5arqr,
  ConcatenatedFormatter as ConcatenatedFormattergumn65iplrh1,
  ConditionalFormatter as ConditionalFormatter2qfqdnibwbifo,
  FormatterStructure as FormatterStructure1ss012tmsg37r,
  SignedFormatter as SignedFormatter14cujr8xyyuqw,
  SpacePaddedFormatter as SpacePaddedFormatter1bbtqhbgrvf8v,
};
//endregion

//# sourceMappingURL=Formatter.mjs.map
